var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadwhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 10.3367V11.1667C1.33337 11.8297 1.59677 12.4656 2.06561 12.9344C2.53445 13.4033 3.17033 13.6667 3.83337 13.6667H12.1667C12.8297 13.6667 13.4656 13.4033 13.9345 12.9344C14.4033 12.4656 14.6667 11.8297 14.6667 11.1667V10.3333M8.00004 0.75V9.91667M8.00004 9.91667L10.9167 7M8.00004 9.91667L5.08337 7",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadwhite);
export default __webpack_public_path__ + "static/media/downloadwhite.43c4681df4cbd6723f2aec7ff53d7985.svg";
export { ForwardRef as ReactComponent };